import { render } from "./form-part-b-general-trust-money.html?vue&type=template&id=628d6e3c&scoped=true&ts=true&external"
import script from "./form-part-b-general-trust-money.ts?vue&type=script&lang=ts&external"
export * from "./form-part-b-general-trust-money.ts?vue&type=script&lang=ts&external"

import "./form-part-b-general-trust-money.scss?vue&type=style&index=0&id=628d6e3c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628d6e3c"]])

export default __exports__